import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({ baseURL: API_BASE });
const getCache = new Map();

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('dasna_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('dasna_token');
      localStorage.removeItem('dasna_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

function buildCacheKey(url) {
  const token = localStorage.getItem('dasna_token') || '';
  return `${token}::${url}`;
}

export function clearGetCache(matcher) {
  if (!matcher) {
    getCache.clear();
    return;
  }
  const keys = Array.from(getCache.keys());
  keys.forEach((k) => {
    if (matcher(k)) getCache.delete(k);
  });
}

export function getCached(url, { ttlMs = 3 * 60 * 1000, force = false } = {}) {
  const key = buildCacheKey(url);
  const now = Date.now();
  const cached = getCache.get(key);

  if (!force && cached) {
    if (cached.data && (now - cached.ts) < ttlMs) {
      return Promise.resolve(cached.data);
    }
    if (cached.promise) {
      return cached.promise;
    }
  }

  const promise = client.get(url)
    .then((res) => {
      getCache.set(key, { ts: Date.now(), data: res, promise: null });
      return res;
    })
    .catch((err) => {
      getCache.delete(key);
      throw err;
    });

  getCache.set(key, { ts: now, data: null, promise });
  return promise;
}

export default client;
